import {
    GET_OPERATION_TYPES_ATTEMPT,
    GET_OPERATION_TYPES_SUCCESS,
    GET_OPERATION_TYPES_FAILURE,
} from "../constants";

import { OperationTypesInitialState } from "../../types/operationTypes";

const initialState: OperationTypesInitialState = {
    fetchingOperationTypesList: 0,
    errorMessage: "",
    success: true,
    operationTypesList: [],
};

export default (state = initialState, action: any) => {
    switch (action.type) {
        // getOperationTypes
        case GET_OPERATION_TYPES_ATTEMPT:
            return {
                ...state,
                fetchingOperationTypesList: state.fetchingOperationTypesList + 1,
                success: true,
                errorMessage: "",
            };
        case GET_OPERATION_TYPES_SUCCESS:
            return {
                ...state,
                fetchingOperationTypesList: state.fetchingOperationTypesList - 1,
                success: true,
                errorMessage: "",
                operationTypesList: validData(action.payload.data),
            };
        case GET_OPERATION_TYPES_FAILURE:
            return {
                ...state,
                fetchingOperationTypesList: state.fetchingOperationTypesList - 1,
                success: false,
                errorMessage: action.payload.error,
            };

        default:
            return state;
    }
};

function validData (data: any[]) {
    return data.filter((element: any) => element.axumOperationTypeCode)
}